"use strict";function e(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var t=e(require("react"));module.exports=function(e){var r=e.children;return e.className,t.default.createElement("tr",null,r)};
//# sourceMappingURL=index.js.map
